export default __webpack_public_path__ + "static/media/internal_icon.53225c47.svg";